module.exports = __webpack_public_path__ + "02_long_brown.0edb0b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_long_brown.png
// module id = X2UC
// module chunks = 0